import React, { PropsWithChildren, useEffect } from 'react';

import Close from '@/assets/icons/close.svg';

import { CreatePortal } from '../create-portal/create-portal';

interface DisplayModalProps {
  handleClose: () => void;
  closable: boolean;
  showBackdrop: boolean;
}

export const DisplayModal = ({
  handleClose,
  closable,
  showBackdrop,
  children,
}: PropsWithChildren<DisplayModalProps>) => {
  useEffect(() => {
    document.body.classList.add('overflow-hidden');
    const closeWithEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        handleClose();
      }
    };

    if (closable) {
      document.body.addEventListener('keydown', closeWithEscape);
    }

    return () => {
      document.body.classList.remove('overflow-hidden');
      document.body.removeEventListener('keydown', closeWithEscape);
    };
  }, [handleClose, closable]);

  const backdropCssClasses = `fixed inset-0 overflow-hidden z-[9999] flex flex-col justify-center items-center${
    showBackdrop ? ' bg-transparency-backdrop' : ''
  }`;

  return (
    <CreatePortal>
      <div
        id="modal"
        className={backdropCssClasses}
        onClick={() => (closable ? handleClose() : null)}
      >
        <div
          onClick={(event) => event.stopPropagation()}
          id="modal-content"
          className={
            'fixed inset-3 rounded-xl bg-brand-white transition-all duration-700 ease-in-out lg:inset-10'
          }
        >
          {closable && (
            <button
              className={
                'absolute top-4 right-4 grid h-8 w-8 place-items-center content-center rounded-full bg-brand-yellow-1 lg:hover:bg-accent-primary-dark focus:bg-accent-primary-dark active:bg-accent-primary-dark lg:top-8 lg:right-8 lg:h-15 lg:w-15'
              }
              onClick={() => handleClose()}
            >
              <Close className={'h-3 w-3 lg:h-5 lg:w-5'} viewBox="0 0 16 16" />
            </button>
          )}
          {children}
        </div>
      </div>
    </CreatePortal>
  );
};
